module.exports = __webpack_public_path__ + "static/img/fredericton3.3ae2dc7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cities/fredericton3.jpg
// module id = 89
// module chunks = 9